import React, { useCallback, useState } from 'react';
import Cookies from 'js-cookie';
import { useSelector } from 'react-redux';
import { ShowMore } from '@yme/atoms/show-more';
import { useIsMount, useWindowSize } from '@yme/hooks/index';
import { getRTL } from '@yme/selectors/common';
import { useTranslation } from '@yme/services/i18n';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { CookieButtons } from '../CookieButtons';
import { COOKIE_SAT_TRACK } from '../constants';
import { allowCookies } from '../helpers';
import { getBannerHeight, getVisibleRows } from './helpers';
import { BannerWrapperStyled, HeadingLevel3Styled, ShowMoreWrapper } from './styled';
export function CookieBanner(props) {
    const { text } = props;
    const [isVisible, setIsVisible] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);
    const isRightToLeft = useSelector(getRTL);
    const isMount = useIsMount();
    const { isInfiniteDesktopView, isTabletView } = useWindowSize();
    const { t } = useTranslation();
    const maxHeight = getBannerHeight({
        isInfiniteDesktopView,
        isTabletView,
        isShowMoreExpanded: isExpanded,
    });
    const maxLinesCount = getVisibleRows({
        isInfiniteDesktopView,
        isTabletView,
    });
    const isAllCookieExists = Boolean(Cookies.get(COOKIE_SAT_TRACK));
    const allowCookiesHandler = useCallback((isAllow) => {
        allowCookies(isAllow);
        setIsVisible(false);
    }, []);
    if (!text || isAllCookieExists) {
        return null;
    }
    return (React.createElement(BannerWrapperStyled, { isFullWidth: true, paddingDesktop: "48px", paddingTablet: "32px 24px", paddingMobile: "24px 16px", isVisible: !isMount && isVisible, isRightToLeft: isRightToLeft, maxHeight: maxHeight, isExpanded: isExpanded, flexDirection: !isInfiniteDesktopView ? 'column' : undefined },
        React.createElement(FlexWrapper, { isFullWidth: true, height: "100%", gap: isInfiniteDesktopView ? '48px' : '24px', alignItems: isInfiniteDesktopView ? 'flex-end' : undefined, flexDirection: !isInfiniteDesktopView ? 'column' : 'row' },
            React.createElement(FlexWrapper, { flexDirection: "column", flex: "1 0" },
                React.createElement(HeadingLevel3Styled, null, t('cookies_weValueYourPolicy_header')),
                React.createElement(ShowMore, { maxLinesCount: maxLinesCount, labelShowLess: t('common_showLess_button'), labelShowMore: t('common_showMore_button'), bottomIndent: "0", wrapper: ShowMoreWrapper, setShowMoreReady: setIsVisible, setIsExpanded: setIsExpanded, isExpanded: isExpanded, keepNewLines: false },
                    React.createElement("div", { dangerouslySetInnerHTML: {
                            __html: text,
                        } }))),
            React.createElement(FlexWrapper, { flexDirection: !isTabletView ? 'column' : undefined, justifyContent: "flex-start", gap: "16px" },
                React.createElement(CookieButtons, { allowCookiesHandler: allowCookiesHandler, buttonWidth: isTabletView ? 'auto' : undefined })))));
}
CookieBanner.displayName = 'CookieBanner_AEMComponent';
